import { FormControlLabel, Switch, SxProps, Theme } from "@mui/material";
import React from "react";

type Props = {
  label: string;
  value: boolean;
  handleChange: (
    event: React.SyntheticEvent<Element, Event>,
    checked: boolean
  ) => void;
  switchStyles?: SxProps<Theme>;
  disabled?: boolean;
};

export const SwitchButton = ({
  label,
  switchStyles,
  handleChange,
  value,
  disabled,
}: Props) => {
  return (
    <FormControlLabel
      control={<Switch checked={value} />}
      label={label}
      onChange={(_, checked) => handleChange(_, checked)}
      disabled={disabled}
      sx={{ ...switchStyles }}
    />
  );
};
